export const subscribePlaceOrder = `subscription SubscribePaceOrder($restaurant:ID!){
    subscribePlaceOrder(restaurant:$restaurant){
      _id
      orderId
      restaurant{
        _id timezone
        name
        image
        address
        location{coordinates}
      }
      deliveryAddress{
        latitude
        longitude
        deliveryAddress
        details
        label
        apartment
        buildingName
        entryCode
        dropoffOption
      }
      items{
        _id
        title
        description
        image
        quantity
        variation{
          _id
          title
          price
          discounted
        }
        addons{
          _id
          options{
            _id
            title
            price
            quantity
            addons{ title additionalCost options{ title price quantity } }
          }
          description
          title
          additionalCost
          quantityMinimum
          quantityMaximum
        }
        specialInstructions
        isActive
      }
      user{
        _id
        name
        phone
        email
      }
      paymentMethod paymentLabel cardBrand cardLast4
      paidAmount
      orderAmount
      walletAmountUsed
      tipping
      taxationAmount
      serviceFee
      orderStatus
      paymentStatus
      reason
      isActive
      isCatering
      createdAt
      deliveryCharges
      instructions
      rider{
        _id
        name
        username
        available
      }
  }
  }`

export const subscriptionOrder = `subscription SubscriptionOrder($id:String!){
    subscriptionOrder(id:$id){
        _id
        orderStatus
        rider{
            _id
        }
    }
  }`

export const subscriptionRiderLocation = `subscription SubscriptionRiderLocation($riderId: ID!) {
  subscriptionRiderLocation(riderId: $riderId) {
    _id
    location { coordinates }
  }
}`

